<template>
    <div class="block__rankingScore">

      <div class="left">
        <div class="title">
          {{titleLeft}}
        </div>
            <div class="bottom">
          <PuSkeleton :loading="isLoading" :count="1" width='40px' height="30px">          
                    <div class="increase">
                    {{objectif}}
                  </div>
                  <div class="objectifOf">
                  {{number}}
                    <span>/{{ofThem}}</span>
                  </div>        
          </PuSkeleton>
            </div>
      </div>

      <div class="right">
        <div class="title">
          {{titleRight}}
        </div>
          <PuSkeleton :loading="isLoading" :count="1" width='40px' height="30px">
            <p class="number">
                {{scoreNumber}}
            </p>
          </PuSkeleton>
      </div>
    </div>
</template>


<script>

export default {
name:"wrapperRankingScore",
  props:{
    titleLeft:{
      type:String,
      default:'Classement'
      },
    titleRight:{
      type:String,
      default:'Score'
      },
    objectif:{
      type:String,
      default:'+1'
      },
    number:{
      type:Number,
      default:1
      },
    scoreNumber:{
      type:Number,
      default:346
      },
    ofThem:{
      type:Number,
      default:4
      }
  },
  data(){
    return {
      isLoading:true,
    }
  },
  mounted () {
  },  
  created(){
    setTimeout(() => {
      this.isLoading = false;
      // this.majData();
    },2000)      
  } 

}
</script>